export default "__VITE_ASSET__D0j93LxJ__"